import { Injectable } from '@angular/core';
import { RobotEscalationWhitelistEvent } from '@ng-cloud/badger-core/models/robot-escalation-whitelist-event';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable()
export class RobotEscalationWhitelistEventService extends ApiService {

  /**
   * Fetch all RobotEscalations
   */
  listWhitelistEvents(params?: any): Observable<RobotEscalationWhitelistEvent[]> {
    let url = `escalation_whitelist_events`;
    return this.http.get<RobotEscalationWhitelistEvent[]>(this.url(url), { params: params }).pipe(
      catchError((err) => this.handleError(err))
    );
  }

  /**
   * Fetch RobotEscalation data for the given id
   */
  getWhitelistEvent(id: string): Observable<RobotEscalationWhitelistEvent> {
    const url = `escalation_whitelist_events/${id}`;
    return this.http.get<RobotEscalationWhitelistEvent>(this.url(url), { params: {} }).pipe(
      catchError((err) => this.handleError(err))
    );
  }

  /**
   * Update RobotEscalation
   */
  updateWhitelistEvent(whitelistEvent: any): Observable<any> {
    const url = `escalation_whitelist_events/${whitelistEvent.name}`;
    const params = {
      enabled: whitelistEvent.enabled,
      priority: whitelistEvent.priority,
      snooze_until: whitelistEvent.snooze_until
    };
    return this.http.patch(this.url(url), params).pipe(
      tap(() => this.cachedRequests.clear()),
      filter(response => !_.isNil(response)),
      catchError(e => this.handleError(e)));
  }

}
